import $ from "jquery";
import gsap from "gsap";

export default class Transition {
    constructor() {
        this.loader = document.getElementById('app-loader');
        this.link = undefined;
    }

    init() {
        this.transition();
    }

    transition = () => {
        const preloader = $('#app-loader');
        // Select all links with hashes
        $('a[href]')
        // Remove links that don't actually link to anything
        .not('[href*="#"]')
        .not('[href*="tel:"]')
        .not('[href*="mailto:"]')
        .not('[target="_blank"]')
        .not('a[download]')
        .on('click', function(e) {

                var link;
                // On-page links
                e.preventDefault();
                preloader.removeClass('active');

                if(e.target.getAttribute('href') == null){
                    link = e.target.parentElement.getAttribute('href');
                } else {
                    link = e.target.getAttribute('href');
                }

                setTimeout(function(){
                    window.location.href = link;
                }, 1000);
            }
        );
    }
}
